// extracted by mini-css-extract-plugin
export default {"zoomModal":"D4-z","image":"E4-z","button":"F4-z","isOverlayShown":"G4-z"};